import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';

export default class FloatCallout extends PureComponent {
  componentDidMount() {
    const { text, type } = this.props;
    toast[type](text, {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  }

  render() {
    return null;
  }
}

FloatCallout.propTypes = {
  text: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['error', 'success', 'warning']).isRequired
};